import { render } from "./DetailModule.vue?vue&type=template&id=125be404&scoped=true"
import script from "./DetailModule.vue?vue&type=script&lang=js"
export * from "./DetailModule.vue?vue&type=script&lang=js"

import "./DetailModule.vue?vue&type=style&index=0&id=125be404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125be404"]])

export default __exports__